export const termsOfUse = 'https://kariusdx.com/terms-of-use-mobile-application-and-customer-portal';
export const privacyPolicy = 'https://kariusdx.com/privacy-policy';

export enum PageUrl {
  eTRF = '/orders/new',
  ordersListView = '/orders',
  kitOrdering = '/kits/new',
  noAuth = '/403',
  login = '/login',
}

export const PublicUrls = ['/login', '/403', '/404', '/500'];
